exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.k-grid[data-v-37f620f0] {\r\n  border-radius: 5px;\r\n  border: 1px solid #0094fb;\r\n  backdrop-filter: blur(10px);\r\n  transition: box-shadow 0.3s ease-in-out, backdrop-filter 0.3s ease-in-out;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);\n}\r\n", ""]);

// exports
